module.exports = __webpack_public_path__ + "static/media/share.70bd74ac.svg";